import type { Column, Table } from '@tanstack/react-table';

interface TableHeadFilterProps {
  column: Column<any>;
  table: Table<any>;
}

export const TableHeadFilter = ({ column, table }: TableHeadFilterProps) => {
  // @ts-ignore
  const { Filter } = column.columnDef;

  if (Filter) {
    return <Filter column={column} table={table} layout="header" />;
  }

  return null;
};
